/**
 * Resolve warehouse code from a merged shipping method row (SFCC + Shipping Options API).
 * Server responses often nest `WhsCode` under `shippingOptionsApi` after collapse.
 *
 * @param {Object|null|undefined} method
 * @returns {string|undefined}
 */
export function getWhsCodeFromShippingMethod(method) {
  if (!method || typeof method !== 'object') {
    return undefined;
  }

  return (
    method.WhsCode ||
    method.whsCode ||
    method.shippingOptionsApi?.WhsCode ||
    method.shippingOptionsApi?.whsCode ||
    undefined
  );
}

/**
 * True when `get-methods` / PDP estimate used Shipping Service data (WhsCode path).
 *
 * @param {string|null|undefined} source
 * @returns {boolean}
 */
export function isShippingServiceApiSource(source) {
  return (
    source === 'SHIPPING_API' ||
    source === 'SHIPPING_API_HYBRID' ||
    source === 'SHIPPING_OPTIONS_API_MOCK'
  );
}

/**
 * First warehouse code on a merged method list (checkout shipping step, PDP delivery block).
 *
 * @param {Array<Object>|null|undefined} methods
 * @returns {string|undefined}
 */
export function getFirstWhsCodeFromMethods(methods) {
  if (!methods?.length) {
    return undefined;
  }

  const withCode = methods.find((m) => getWhsCodeFromShippingMethod(m));

  return getWhsCodeFromShippingMethod(withCode);
}
